import React from "react";
import { SelectGroup, SelectItem, SelectLabel, SelectSeparator } from "../ui/select";

export const ORGS = ["EP Group", "Harrods"];

// Grouped team-member options: EP Group first, then Harrods contacts
export function MemberItems({ team }) {
  return ORGS.map((org, i) => {
    const members = team.filter((m) => (m.org || "EP Group") === org);
    if (!members.length) return null;
    return (
      <React.Fragment key={org}>
        {i > 0 && <SelectSeparator />}
        <SelectGroup>
          <SelectLabel className={`text-[10px] font-bold uppercase tracking-wider ${org === "Harrods" ? "text-[#a08450]" : "text-slate-400"}`}>
            {org === "Harrods" ? "Harrods contacts" : "EP Group team"}
          </SelectLabel>
          {members.map((m) => (
            <SelectItem key={m.id} value={m.id}>
              {m.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </React.Fragment>
    );
  });
}

export const OrgBadge = ({ org, className = "" }) =>
  org === "Harrods" ? (
    <span className={`inline-flex items-center rounded-full border border-[#e7dcc6] bg-[#fbf8f1] px-2 py-0.5 text-[10px] font-semibold text-[#a08450] ${className}`}>
      Harrods
    </span>
  ) : (
    <span className={`inline-flex items-center rounded-full bg-[#e8f1ed] px-2 py-0.5 text-[10px] font-semibold text-[#00573f] ${className}`}>EP Group</span>
  );
